import {FITH2Symbol, ISymbolData, FITH2SymbolStates} from "./FITH2Symbol";
import {gsap} from "gsap";
import {FireInTheHole2} from "../FireInTheHole2";
import {FITH2Helper} from "../utils/FITH2Helper";
import {SpineTween} from "@nolimit/slot-game/bin/animation/SpineTween";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";

export class FITH2Split extends FITH2Symbol {

    constructor(symbolData:ISymbolData, state:FITH2SymbolStates = FITH2SymbolStates.NORMAL) {
        super(symbolData);
        this._spine = new PIXI.spine.Spine(FireInTheHole2.assetLoader.getSpineAsset("XS"));
        if(!this.isBehindDirt) {
            this.addChild(this._spine);
            this._currentStateSprite.visible = false;
            this._spine.state.setAnimation(0, "base", false);
        }
    }

    public playLandingAnimation():gsap.core.Timeline {
        if(this.isBehindDirt) {
            return gsap.timeline();
        }

        return gsap.timeline().add([
            () => {
                this.parent.removeChild(this);
                FireInTheHole2.reelArea.allReels[this.reelId].reelView.scatterWinView.addChild(this);
                FITH2SoundManager.playXSLandingSound();
            },
            new SpineTween(this._spine!, 0, "land")
        ]);
    }

    public splitSymbolHighlight():SpineTween {
        return new SpineTween(this._spine!, 0, "trigger");
    }

    public disappear():SpineTween {
        return new SpineTween(this._spine!, 0, "disappear");
    }

    protected removeDirt(fromSplit:boolean = true):gsap.core.Timeline {
        return super.removeDirt(fromSplit).add(() => {
            this._currentStateSprite.visible = false;
            this.addChild(this._spine!);
            this._spine!.state.setAnimation(0, "base", false);
        });
    }
}